module.exports = __webpack_public_path__ + "img/appltCourse-img39.32106a3a.png";